export enum EAdminPostQueryKey {
  ADMIN_DELETE_PROJECT_POST = 'admin-delete-project-post',
  ADMIN_AUDIT_PROJECT_POST = 'admin-audit-project-post',
  ADMIN_LIST_PROJECT_POSTS = 'admin-list-project-posts',
}
